/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';

export default declareLinkedEntity({
    entity: "screenDataSourceToAdd",
    graphQL: "ScreenDataSourceToAdd",
    name: "DataSource To Add",
    storageType: 'central',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "DataSource to Add ID",
            type: "string",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        icon: {
            name: "Icon",
            type: "string",
        },
        name: {
            name: "Name",
            translatable: true,
            type: "string",
        },
        description: {
            name: "Description",
            translatable: true,
            type: "string",
        },
        type: {
            name: "Handler",
            type: "string",
        },
        uiAddHandler: {
            name: "UI Handler for Adding",
            type: "string",
        },
        group: {
            name: "Group",
            type: "string",
        },
        typeId: {
            name: "Type ID",
            description: "Type ID that allows to find existing datasources in query",
            type: "string",
        },
        keepUnique: {
            name: "Keep unique",
            description: "Protect against adding the same data source twice.",
            type: "boolean",
            defaultValue: false,
        },
        screen: {
            name: "Screen",
            type: "relation",
            to: () => types['screens'],
            defaultValue: (screen) => {
                return screen['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
        },
        channelDef: {
            name: "Attached Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
        },
        relativeTo: {
            name: "Data Source",
            type: "relation",
            to: () => types['dataSources'],
            hiddenCreate: true,
            relativeTo: ['screen'],
        },
        channel: {
            name: "Connected Application",
            description: "If this data source needs some application, this is the connection",
            type: "relation",
            to: () => types['channels'],
        },
        helperChannel: {
            name: "Helper Application",
            description: "If this data source needs some application, this is the connection",
            type: "relation",
            to: () => types['channels'],
        },
        helperChannelDef: {
            name: "Helper Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
        },
        helperEntityDef: {
            name: "Helper Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
        },
    }; },
    relations: (types) => { return {
    }; }
});
